'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
  var requireLogin = function requireLogin(nextState, replace, cb) {
    var _store$getState = store.getState(),
        token = _store$getState.auth.token;

    if (!token) {
      replace('/login');
    }
    cb();
  };

  /**
   * Please keep routes in alphabetical order
   */
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App },
    _react2.default.createElement(
      _reactRouter.Route,
      { onEnter: requireLogin, component: _containers.Manager },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.SchoolLevels }),
      _react2.default.createElement(_reactRouter.Route, { path: 'schoollevels', component: _containers.SchoolLevels }),
      _react2.default.createElement(_reactRouter.Route, { path: 'schoollevels/new', component: _containers.NewSchoolLevel }),
      _react2.default.createElement(_reactRouter.Route, { path: 'schoollevels/:schoolLevelId', component: _containers.SchoolLevel }),
      _react2.default.createElement(_reactRouter.Route, { path: 'schoollevels/:schoolLevelId/chapters/:chapterId', component: _containers.Chapter }),
      _react2.default.createElement(_reactRouter.Route, { path: 'documents', component: _containers.Documents }),
      _react2.default.createElement(_reactRouter.Route, { path: 'schoollevels/:schoolLevelId/chapters/:chapterId/documents/:documentId', component: _containers.Document }),
      _react2.default.createElement(_reactRouter.Route, { path: 'schoollevels/:schoolLevelId/chapters/:chapterId/lessons/:documentId', component: _containers.LessonSheet }),
      _react2.default.createElement(_reactRouter.Route, { path: 'schoollevels/:schoolLevelId/chapters/:chapterId/mcq/:documentId', component: _containers.MCQ }),
      _react2.default.createElement(_reactRouter.Route, { path: 'schoollevels/:schoolLevelId/chapters/:chapterId/quiz/:documentId', component: _containers.Quiz }),
      _react2.default.createElement(_reactRouter.Route, { path: 'synchronization', component: _containers.Synchronization })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'login', component: _containers.Login }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 1217
// module chunks = 0